<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title>
           {{state=='new'? 'Add': "Edit"}} {{trans_type}}
        </v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
             
                <v-text-field
                 single-line
                 v-model="entry.amount"
                 dense
                  label="Amount"
                  :rules="textRules"
                required
                outlined
                ></v-text-field>
                <v-autocomplete
                 v-model="entry.remarks"
                 dense
                  label="Remarks"
                  :items="['Partial Payment', 'Full Payment']"
                  single-line
                  :rules="textRules"
                  required
                  outlined
                ></v-autocomplete>
               

                <!-- <v-autocomplete
                 v-model="entry.status"
                 dense
                  label="Status"
                  :items="status"
                  single-line
                  :rules="textRules"
                required
                ></v-autocomplete> -->

             </v-form>
              <v-divider class="mt-5"/>
        </v-card-text>
        <v-card-actions>
           
                <v-btn color="warning"  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn   color="success"   @click="validate()">Add Payment</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
    show: {
        type: Boolean,
        default: false
    },
    account: {
         type: Object,
        default: ()=>{}
    },
    account_type: {
         type: Number,
        default: 0
    },
    trans_type: {
         type: String,
        default: ""
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      entry:{},
      types:[{id: 1, name: "Collectible"}, {id: 2, name: "Payable"},
       {id: 3, name: "Payout"}, {id: 4, name: "Payment"},  {id: 5, name: "SC Payment"}, {id: 6, name: "TF Payment"}],
       status:['verified','request'],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      TRANS_TYPES() {
        if(this.account_type == 1) {
            return [{id: 3, name: "Payout/Expenses"}]
        } else if(this.account_type == 2) {
            return [{id: 1, name: "Collectible"}, {id: 2, name: "Payable"},  {id: 3, name: "Payout"}]
        } else {
            return this.types
        }
      }
  },
  watch: {
    show (v) {
      if (!v) {
        this.entry = {}
      } else {
        this.entry.account = this.account.id
        this.entry.type=this.setType()
        this.entry.status='verified'
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
            this.entry.account_type = this.account_type
                this.Add()
        }
      },
      setType(){
        let typeID = this.types.reduce((res,item)=>{
          if(item.name==this.trans_type) {
            res=item.id
          }
          return res
        },0)
        return typeID
      },
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    Add(){
      this.entry.account = this.$IsNum(this.account.id)
        this.$http.post("transaction/add", this.entry).then(response => {
            response.data.status?this.VA_ALERT('success', response.data.message):this.VA_ALERT('success', response.data.message)
            this.$emit('DialogEvent', 'close')
        }).catch(e => {
        console.log(e.data)
        })
    }
  }
}
</script>
